export enum DateButtons {
  today = "today",
  tomorrow = "tomorrow",
  week = "week",
  all = "all",
}
